import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/styles";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

export default function ({ label, value }) {
    return <StyledSingleInfo>
        <Typography>
            {label}
        </Typography>
        <Typography variant='bold'>
            {value}
        </Typography>
        <Divider />
    </StyledSingleInfo>
};

const StyledSingleInfo = styled(Box)(({ theme }) => ({
    '& .MuiTypography-root': {
        fontSize: '20px'
    }
}));